<template>
  <div
    class="card chart-card"
    style="height: 315px; border-radius: 5px; margin-bottom: 15px"
  >
    <!-- style="height: 283px" -->
    <div class="d-flex card-header portfolioPerformanceChartTitle">
      <div class="dashboard-cards-header">
        <el-select
          class="dashboardPerformanceDropdown dashboardCategoryDropdown-el-select dashboardCategoryDropdown1 select-primary"
          size="small"
          placeholder
          @change="categoryChange"
          v-model="category.selected"
        >
          <el-option
            v-for="option in categoryDropdown"
            class="select-primary"
            :value="option.value"
            :label="option.label"
            :key="option.label"
          ></el-option>
        </el-select>
      </div>
      <div
        style="margin-top: auto; margin-bottom: auto"
        v-tooltip.top-end="toolTipInfo"
      >
        <img src="static/img/graphInfo.svg" class />
      </div>
    </div>
    <div class="portfolioPerformanceChart">
      <div v-if="category.selected == 'active' || category.selected == 'exit'">
        <div v-if="activeCompanies.data.length > 0">
          <table class="portfolioPerformanceTable w-100">
            <tr class="portfolioPerformanceTableHeading">
              <th>COMPANY NAME</th>
              <th style="text-align: center">
                <!-- {{ category.selected == "active" ? "COST" : "GAIN" }} -->
                COST
              </th>
              <th style="text-align: center">
                {{
                  category.selected == "active"
                    ? "CURRENT VALUE"
                    : "EXITED VALUE"
                }}
              </th>
            </tr>
            <tr
              v-for="field in activeCompanies.data"
              :key="field._id"
              class="portfolioPerformanceTableLoop"
            >
              <td
                style="color: #5445f3; cursor: pointer"
                class="portfolioPerformanceTableTd"
                @click="navigateToProfile(field)"
              >
                {{ field.name }}
              </td>
              <!-- <td
                style="text-align: center"
                v-if="category.selected != 'active' && field.gain_loss >= 0"
              >
                ${{ formatNumberWithComma(field.gain_loss) }}
              </td>
              <td
                style="text-align: center"
                v-else-if="category.selected != 'active' && field.gain_loss < 0"
              >
                -${{ formatNumberWithComma(field.gain_loss * -1) }}
              </td> -->
              <td style="text-align: center" v-if="field.cost == 0">$0</td>
              <td style="text-align: center" v-else>
                ${{ formatNumberWithComma(field.cost) }}
              </td>
              <!-- <td
                style="text-align: center"
                v-if="category.selected != 'active'"
              >
                {{ field.multiple }}
              </td> -->
              <td style="text-align: center" v-if="field.value > 0">
                ${{ formatNumberWithComma(field.value) }}
              </td>
              <td style="text-align: center" v-if="field.value < 0">
                -${{ formatNumberWithComma(field.value * -1) }}
              </td>
              <td style="text-align: center" v-if="field.value == 0">$0</td>
            </tr>
          </table>
        </div>
        <div v-else class="w-100">
          <div style="justify-content: center; display: flex; color: #707070">
            No records to view
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Select, Option } from "element-ui";
import { mapGetters } from "vuex";
import _ from "lodash";
import ChartjsPie from "../../components/Chartjs/ChartjsPie";
import { formatNumberWithComma } from "../../util";
export default {
  name: "portfolioPerformanceTable",
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
    ChartjsPie,
  },
  data() {
    return {
      category: {
        selected: "exit",
      },
      ceoDataSets: [],
      ceoLabels: [],
      founderDataSets: [],
      founderLabels: [],
      founderTextCenterLabel: [],
      ceoTextCenterLabel: [],
    };
  },
  computed: {
    ...mapGetters("portfolio", ["portfolioData"]),
    categoryDropdown() {
      let dropDownArray = [];
      dropDownArray[0] = { label: "Top 5 Exited Companies", value: "exit" };
      dropDownArray[1] = {
        label: "Top 5 Active Companies",
        value: "active",
      };
      return dropDownArray;
    },
    activeCompanies() {
      let values = JSON.parse(JSON.stringify(this.portfolioData));
      values = _.map(values, (data) => {
        data["multiple"] = this.computeMultiple(data);
        data["gain_loss"] = this.computeGainLoss(data);
        data["status"] = data["status"] ? data["status"] : "Unknown";
        return data;
      });
      values = _.sortBy(values, [
        function (pd) {
          return -pd.gain_loss;
        },
      ]);
      let loopData = {};
      let activeValues = values.filter(
        (item) =>
          item.status &&
          item.data_status == "Confirmed" &&
          !["Acquired", "Out of Business", "Exit", "IPO"].includes(item.status)
      );
      loopData.active =
        activeValues.length >= 5 ? activeValues.slice(0, 5) : activeValues;
      let exitValues = values.filter(
        (item) =>
          item.status &&
          item.data_status == "Confirmed" &&
          ["Acquired", "Out of Business", "Exit", "IPO"].includes(item.status)
      );
      loopData.exit =
        exitValues.length >= 5 ? exitValues.slice(0, 5) : exitValues;

      return {
        data: loopData[this.category.selected],
        placeholder: "No records to view",
      };
    },
    toolTipInfo() {
      if (this.category.selected == "active") {
        return "The companies listed have the largest value to cost ratio out of the funds portfolio";
      } else if (this.category.selected == "exit") {
        return "The companies listed have the largest value gain and multiple out of the funds portfolio";
      }
    },
  },
  methods: {
    categoryChange() {
      if (
        this.category.selected == "active" ||
        this.category.selected == "exit"
      ) {
        this.activeCompanies;
      }
    },
    computeMultiple(data) {
      return data.cost &&
        data.value &&
        Number(data.cost) > 0 &&
        Number(data.value) > 0
        ? (Number(data.value) / Number(data.cost)).toFixed(2)
        : 0;
    },
    computeGainLoss(data) {
      return data.value >= 0 && data.cost >= 0 ? data.value - data.cost : 0;
    },
    navigateToProfile(item) {
      let self = this;
      if (item.ucid) {
        self.$store.commit("temp/currentCompany", item.ucid);
        self.$router.push(
          `/${self.$route.params.account_id}/${self.$route.params.workspace_id}/companyProfile/${item.ucid}`
        );
      }
    },
    formatNumberWithComma,
  },
  mounted() {
    this.categoryChange();
    let self = this;
    this.$store
      .dispatch("charts/getGenderChartData")
      .then((data) => {
        if (self.genderChartData) {
          self.createPrimaryDataset();
        }
      })
      .catch((error) => {
        console.log("error", error);
      });
  },
  watch: {
    $route(to, from) {
      this.category.selected = "exit";
    },
  },
};
</script>
<style>
.dashboardPerformanceDropdown .el-input {
  width: 270px !important;
  /* width: 365px !important; */
}
.portfolioPerformanceTableHeading {
  border-bottom: 1px solid #707070;
}
.portfolioPerformanceTableLoop {
  border-bottom: 1px solid rgba(112, 112, 112, 0.09);
}
.portfolioPerformanceTableTd:hover {
  text-decoration: underline;
}
</style>